import { LocalStorageUtils } from '@brunommsilva/react-foundations';
import { useSyncExternalStore } from 'react';

const PINNED_KEY = 'assistant_pinned';

const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () =>
  LocalStorageUtils.getItem<boolean>(PINNED_KEY) === true;

const setPinned = (pinned: boolean) => {
  LocalStorageUtils.setItem(PINNED_KEY, pinned);
  listeners.forEach((listener) => listener());
};

/** Whether the assistant of a large screen is docked at the side, kept between visits. */
const useAssistantPinned = () => {
  const isPinned = useSyncExternalStore(subscribe, getSnapshot);

  return { isPinned, setPinned };
};

export default useAssistantPinned;
